/**
 * Elements migrated from Slate 0.45 `object: "inline"` nodes carry `isInline: true`
 * (set by package-gen). Types without a dedicated plugin (e.g. `text`, `screen-link`,
 * `toolTip`) would otherwise be treated as blocks, and Slate's normalize removes block
 * children from inline-content paragraphs, dropping them along with any key-terms inside.
 * Must stay last in the plugin list so dedicated plugins render their own types first.
 */

// Packages generated before package-gen emitted `isInline` lack the flag; these types
// only ever occur as legacy inlines, so treat them as inline regardless.
const UNFLAGGED_LEGACY_INLINE_TYPES = new Set([
  "text",
  "screen-link",
  "inline-text",
  "inline-dropdown",
  "toolTip",
]);

const isLegacyInline = (element: any): boolean =>
  element?.isInline === true || UNFLAGGED_LEGACY_INLINE_TYPES.has(element?.type);

export default function LegacyInline() {
  const plugin = (editor: any) => {
    const { isInline } = editor;
    editor.isInline = (element: any) => isLegacyInline(element) || isInline(element);
    return editor;
  };

  plugin.renderElement = ({ element, attributes, children }: any) => {
    if (!isLegacyInline(element)) {
      return undefined;
    }
    const dataId = element.data?.dataId || element.data?.id;
    return (
      <span {...attributes} data-id={dataId}>
        {children}
      </span>
    );
  };

  return plugin;
}
